import { orderDetailAdapter } from './orderDetail.adapter';
import { orderDetailRepository } from './orderDetail.repository';

import type { OrderId } from 'shared/domain';

export async function getOrderDetailById(orderId: OrderId) {
  return orderDetailRepository
    .readOrderDetailById(orderId)
    .then(r => orderDetailAdapter.toOrderDetailModel(r.data));
}
